module.exports = __webpack_public_path__ + "img/upload.9870b828.png";